import { Model } from "@vuex-orm/core";
import Vue from 'vue'
import _ from 'lodash'
import shortid from 'shortid'
import Request from "./Request"
import Product from './Product'
import PaymentMethod from './PaymentMethod'
import PhoneLine from './PhoneLine'
import moment from 'moment'
import store from '../store' 

export default class STATE_Request extends Model {
    static entity = "STATE_requests";
    static fields() {
        return {
            id: this.attr(null),
            request: this.belongsTo(Request, 'requestId'),
            requestId: this.attr(null),
            requestZepplinId: this.attr(null),
            requestDateCreated: this.attr(null),
            requestCode: this.attr(null),
            contactId: this.attr(null),
            hasCard: this.attr(true),
            companyId: this.attr(null),
            deliveryCompanyId: this.attr(null),
            card: this.attr({
                company: {
                    id: null,
                    name: null,
                    lngLat: null
                },
                deliveryCompany: {
                    id: null,
                    name: null
                },
                requestCode: null,
                contactId: null,
                requestContactName: null,
                requestContactAddressName: null,
                responsibleUserName: null,
                contactAddressId: null,
                contactAddressLat: null,
                contactAddressLng: null,
                orderSubtotal: null,
                deliveryDate: null,
                cardStatus: 'draft',
                isScheduled: null,
                quantityProducts: null,
                quantityServices: null,
                unreadRequestChatItems: 0
            }),
            hasWindow: this.attr(true),
            window: this.attr({
                show: false,
                zIndex: 0,
                onFocus: false,
                x: 20,
                y: 20
            }),
            loadedRequestHistory: this.attr(false),
            requestHistory: this.attr({
                list: [],
                total: null
            }),
            obs: this.attr(null),
            phoneLineId: this.attr(null),
            phoneLine: this.belongsTo(PhoneLine, 'phoneLineId'),
            status: this.attr(null),
            persistedStatus: this.attr(null),
            loading: this.attr({
                show: false,
                text: null
            }),
            totalSearch: this.attr(0),
            activeTab: this.attr('order'),
            activeRequestOrderTab: this.attr('products'),
            responsibleUserIdPersisted: this.attr(null),
            isMasterPanel: this.attr(null)
        }
    }

    /**
     * @still_implementing
     * Denormalizete Request Informations to use into card, window and request.
     * @returns Object denormatizeted 
     * @param {Object} request 
     * @param {String} cardStatus 
     * @param {Boolean} hasCard 
     * @param {Boolean} hasWindow 
     */
    static denormalizeRequest(request, cardStatus = 'draft', hasCard = true, hasWindow = true, isMasterPanel = false) {
        let responsibleUserId, requestContactId, requestOrderId
        let contactTmpId = `tmp/${shortid.generate()}`, contactAddressTmpId = `tmp/${shortid.generate()}`, contactPhoneTmpId = `tmp/${shortid.generate()}`
        let responsibleUserTmpId = `tmp/${shortid.generate()}`, requestContactTmpId = `tmp/${shortid.generate()}`, requestOrderTmpId = `tmp/${shortid.generate()}`
        let requestOrderProductTmpId = `tmp/${shortid.generate()}`, requestOrderPaymentTmpId = `tmp/${shortid.generate()}` 
        let requestOrderServiceTmpId = `tmp/${shortid.generate()}`

        let denormalizedRequest = {}
        let addressName = null
        if(_.result(request, 'requestContact') && request.requestContactId) {
            requestContactId = request.requestContactId
            _.assign(denormalizedRequest, {
                requestContact: request.requestContact
            })
            if(_.result(request, 'requestContact') && request.requestContactId && hasCard) {
                if(_.result(request.requestContact, 'contactAddress.address')) {
                    addressName = 
                        `${request.requestContact.contactAddress.address.name ? request.requestContact.contactAddress.address.name : 'S/ Endereço'}, ` + 
                        `${request.requestContact.contactAddress.number ? request.requestContact.contactAddress.number : 'S/ N' } $#! ` + 
                        `${request.requestContact.contactAddress.address.neighborhood ? request.requestContact.contactAddress.address.neighborhood : 'S/ Bairro'}`
                }
            }
        } else {
            let objRequestContact = {
                id: requestContactTmpId,
                contactId: contactTmpId,
                contactAddressId: contactAddressTmpId,
                contactPhoneId: contactPhoneTmpId
            }
            _.assign(denormalizedRequest, {
                requestContact: objRequestContact
            })
            requestContactId = requestContactTmpId
        }
        let subtotal = 0
        let quantityProducts = 0
        let quantityServices = 0
        if(_.result(request, 'requestOrder') && request.requestOrderId) {
            requestOrderId = request.requestOrderId
            _.assign(denormalizedRequest, {
                requestOrder: request.requestOrder
            })
            if (_.result(request, 'requestOrder.requestOrderProducts')) {
                request.requestOrder.requestOrderProducts.forEach((value) => {
                    if(value.productId){ 
                        quantityProducts += value.quantity
                        subtotal += (value.quantity * (value.unitPrice - value.unitDiscount))
                    }
                })
            }
            if (_.result(request, 'requestOrder.requestOrderServices')) {
                request.requestOrder.requestOrderServices.forEach((value) => {
                    if(value.serviceId){ 
                        quantityServices += 1
                        subtotal += (value.price - value.discount)
                    }
                    
                })
            }
        } else {
            _.assign(denormalizedRequest, {
                requestOrder: { 
                    id: requestOrderTmpId,
                    requestOrderProducts: [{ id: requestOrderProductTmpId }],
                    requestOrderServices: [{ id: requestOrderServiceTmpId }],
                    requestOrderPayments: [{ id: requestOrderPaymentTmpId }]
                } 
            })
            requestOrderId = requestOrderTmpId
        }
        if(_.result(request, 'responsibleUser') && request.responsibleUserId) {
            responsibleUserId = request.responsibleUserId
            _.assign(denormalizedRequest, {
                responsibleUser: request.responsibleUser,
                responsibleUserIdPersisted: responsibleUserId
            })
        } else {
            _.assign(denormalizedRequest, {
                responsibleUser: responsibleUserTmpId
            })
            responsibleUserId = responsibleUserTmpId
        }

        let company = null
        if(typeof request.company === 'object') {
            let lngLat = null
            if(Array.isArray(request.company.companySettings)) {
                const lng = request.company.companySettings.find(companySetting => companySetting.key === 'baseLng')
                const lat = request.company.companySettings.find(companySetting => companySetting.key === 'baseLat')
                if(lng && lat)
                    lngLat = [lng.value, lat.value]
            }
            company = {
                id: request.company.id,
                name: request.company.name,
                lngLat
            }
        }
        let deliveryCompany = null
        if(typeof request.deliveryCompany === 'object' && request.deliveryCompany) {
            deliveryCompany = {
                id: request.deliveryCompany.id,
                name: request.deliveryCompany.name
            }
        }
        if(hasCard){
            _.assign(denormalizedRequest, {
                card: {
                    company,
                    deliveryCompany,
                    requestCode: request.code,
                    contactId: request.requestContact && request.requestContact.contact ? request.requestContact.contact.id : null,
                    requestContactName: request.requestContact && request.requestContact.contact ? request.requestContact.contact.name : null,
                    requestContactAddressName: addressName,
                    contactAddressId: _.result(request,"requestContact.contactAddress.id",null),
                    contactAddressLat: _.result(request,"requestContact.contactAddress.lat",null),
                    contactAddressLng: _.result(request,"requestContact.contactAddress.lng",null),
                    responsibleUserName: request.responsibleUser ? request.responsibleUser.name : null,
                    cardStatus,
                    orderSubtotal: subtotal,
                    quantityProducts,
                    quantityServices,
                    deliveryDate: request.deliveryDate,
                    isScheduled: request.isScheduled,
                    unreadRequestChatItems: request.unreadRequestChatItems && request.unreadRequestChatItems > 0 ? request.unreadRequestChatItems : 0 
                }
            })
        }
        if(hasWindow) {
            _.assign(denormalizedRequest, {
                window: {
                    show: false,
                    zIndex: 0,
                    x: 20,
                    y: 20
                }
            })
        }

        return _.assign(denormalizedRequest, { 
            id: `tmp/${shortid.generate()}`,
            requestId: request.id ? request.id : `tmp/${shortid.generate()}`,
            requestCode: request.code,
            requestZepplinId: request.zepplinId, 
            contactId: request.requestContact ? request.requestContact.contactId : null, 
            companyId: request.companyId,
            deliveryCompanyId: request.deliveryCompanyId,
            hasCard,
            hasWindow,
            requestContactId,
            requestOrderId,
            responsibleUserId,
            status: request.status ? request.status : null,
            persistedStatus: request.status,
            phoneLineId: request.phoneLineId,
            requestDateCreated: request.dateCreated,
            isMasterPanel
        })
    }

    /**
     * This method open the window request and add into VUEX ORM states
     */
    async openWindow(ctx, cardStatus = 'editing') {
        const vm = this
        try {
            STATE_Request.query().where(record => record.window.onFocus)
                .get()
                .forEach(STATE_request => {
                    STATE_request.$update({
                        where: STATE_request.id,
                        data: {
                            window: {
                                ...STATE_request.window,
                                onFocus: false
                            }
                        }
                    })
                })

            await vm.$update({
                where: vm.id,
                data: {
                    card: vm.hasCard ? {
                        ...vm.card,
                        cardStatus
                    } : null,
                    window: {
                        ...vm.window,
                        show: true,
                        zIndex: _.max(_.map(ctx.VXORM.STATE_Request.all(),(STATE_request) => STATE_request.window.zIndex),(STATE_request) => {
                            return STATE_request.window.zIndex
                        }) + 1,
                        onFocus: true
                    },
                    loading: {
                        show: true,
                        text: "Abrindo atendimento..."
                    }
                }
            })
            const requestId = await ctx.VXORM.Request.load(ctx,vm.requestId)
            return await vm.$update({
                where: vm.id,
                data: {
                    requestId: requestId,
                    loading: {
                        show: false,
                        text: null
                    }
                }
            })
        } catch (err) {
            this.closeWindow(ctx)
            throw new Error(err)
        }
    }

    closeWindow(ctx) {
        const vm = this

        vm.$update({
            where: vm.id,
            data : {
                card: vm.hasCard ? {
                    ...vm.card,
                    cardStatus: Number.isInteger(vm.requestId) ? 'pending' : 'draft'
                } : null,
                window: {
                    ...vm.window,
                    show: false
                }
            }
        })
        let request = null
        if(vm.requestId)
            request = Request.query()
                .with('responsibleUser')
                .with('requestContact')
                .with('requestContact.contact')
                .with('requestContact.contact.contactRequestContacts')
                .with('requestContact.contact.contactPhones')
                .with('requestContact.contact.contactAddresses')
                .with('requestContact.contact.contactAddresses.address')
                .with('requestContact.contact.contactAddresses.address.addressContactAddresses')
                .with('requestContact.contactPhone')
                .with('requestContact.contactAddress')
                .with('requestOrder')
                .with('requestOrder.requestOrderProducts')
                .with('requestOrder.requestOrderServices')
                .with('requestOrder.requestOrderPayments')
                .find(vm.requestId)

        if(request) {
            request.deleteAllInRequest()
            Vue.nextTick(() => {
                if(!Number.isInteger(request.id) || !vm.hasCard || vm.card.cardStatus === 'draft' ||
                    (!Number.isInteger(request.id) && request.status != 'pending' && request.status != 'in-provision' && request.status != 'in-displacement' && request.status != 'sent') || 
                    (!Number.isInteger(request.id) && request.isScheduled && moment(request.deliveryDate).local().day() != moment(store.state['request-board'].filters.deliveryDate).local().day())
                    && !request.zepplinId) 
                    vm.$delete(vm.id)

                setTimeout(() => {
                    if((ctx.company.id != request.companyId || vm.isMasterPanel) && request) {
                        request.requestOrder.requestOrderProducts.forEach(requestOrderProduct => {
                            const _productId = requestOrderProduct.productId
                            const products = Product.query().where('id', _productId).get()
                            if(products && products.length === 1) 
                                Product.deleteById(_productId)
                        })
                        request.requestOrder.requestOrderPayments.forEach(requestOrderPayment => {
                            const _paymentMethodId = requestOrderPayment.paymentMethodId
                            const paymentMethods = PaymentMethod.query().where('id', _paymentMethodId).get()
                            if(paymentMethods && paymentMethods.length === 1)
                                PaymentMethod.deleteById(_paymentMethodId)
                        })
                    }
                }, 100)
            })
        }

    }

}